import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadRecord, reset } from "../../patientDetails/patientDetailsSlice";

export const useOpportunitiesActions = (
  patient_opportunity_statuses,
  location
) => {
  const [createOpportunityVisible, setCreateOpportunityVisible] =
    useState(false);
  const [selectionActionModalVisible, setSelectionActionModalVisible] =
    useState(false);
  const [wizardType, setWizardType] = useState();
  const [selectionActionLoading, setSelectionActionLoading] = useState(false);
  const [selectionAction, setSelectionAction] = useState(null);
  const [textFilter, setTextFilter] = useState(null);
  const [irrelevantStatusId, setIrrelevantStatusId] = useState(null);
  const [transferPatientVisible, setTransferPatientVisible] = useState(false);
  const [page, setPage] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  useEffect(() => {
    if (
      patient_opportunity_statuses &&
      patient_opportunity_statuses.length > 0
    ) {
      const irrelevantStatus = patient_opportunity_statuses.find(
        (i) => i.name === "irrelevant"
      );
      if (irrelevantStatus) {
        const irrelevantId = irrelevantStatus.id;
        setIrrelevantStatusId(irrelevantId);

        const initialPage = {
          current: 1,
          pageSize: 10,
          filter: {
            freeText: textFilter,
            $or: [{ status_id: 3 }],
            $and: [
              {
                opportunity_status_id: {
                  $neq: irrelevantId,
                },
              },
            ],
          },
          order: {
            field: "updated_at",
            order: "descend",
          },
          items: [],
          fields:
            "first_name,surename,status_id,local_id_number,contact_info,birthday,gender_id,address,avatar_url,id,branch_id,branch,opportunity_status_id,updated_at,created_at",
        };
        setPage(initialPage);
      }
    }
  }, [patient_opportunity_statuses]);

  const onLaunchCreateOpportunityModal = async (record, val) => {
    setWizardType(val === "edit" ? "convert" : "candidate");
    if (val === "edit") {
      const isAdmin = location.pathname.includes("admin");
      const params = {
        id: record.id,
        branchId: record.branch,
        admin: isAdmin,
      };
      await dispatch(loadRecord(params));
    }
    setCreateOpportunityVisible(true);
  };

  const hideOpportunityModal = () => {
    setCreateOpportunityVisible(false);
    dispatch(reset());
  };

  const onLaunchSelectionActionModal = (source) => {
    setSelectionAction(source);
    setSelectionActionModalVisible(true);
  };

  const hideSelectionActionModal = () => {
    setSelectionActionModalVisible(false);
  };

  const getPatient = (id, branchId) => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id,
      branchId,
      admin: isAdmin,
    };
    dispatch(loadRecord(params));
  };

  const onLaunchChangeBranch = (record) => {
    getPatient(record.id, record.branch);
    setTransferPatientVisible(true);
  };

  const onHideTransferPatient = () => {
    setTransferPatientVisible(false);
    dispatch(reset());
  };

  const onTextChange = (e) => {
    setTextFilter(e.target.value);
    setPage({ ...page, filter: { ...page.filter, freeText: e.target.value } });
  };

  const onStaffInchargeChange = (value) => {
    let newFilters = page.filter;

    // Remove any existing staff_worker_in_charge_id filters
    if (newFilters.$and) {
      newFilters = {
        ...newFilters,
        $and: newFilters.$and.filter(
          (condition) =>
            !Object.prototype.hasOwnProperty.call(
              condition,
              "staff_worker_in_charge_id"
            )
        ),
      };
    }
    if (value) {
      newFilters = {
        ...newFilters.filter,
        $and: [
          ...(newFilters.filter?.$and ? newFilters.filter.$and : []),
          { staff_worker_in_charge_id: value },
        ],
        freeText: page.filter.freeText,
      };
    }

    setPage({ ...page, filter: newFilters });
  };

  const onChange = (
    { current, pageSize },
    filters,
    { field, order },
    extra
  ) => {
    const filtersType = { gender_id: "number" };
    const pageNumber = extra["action"] === "paginate" ? current : 1;
    let keys = Object.keys(filters);

    const filter = keys.reduce((acc, key) => {
      if (filters[key]) {
        const temp = filters[key].map((item) => ({
          [key]:
            filtersType[key] === "number"
              ? parseInt(item)
              : filtersType[key] === "boolean"
              ? item === true
              : item,
        }));

        acc["$and"] = acc["$and"] || [];
        acc["$and"].push({ $or: temp });
      }

      return acc;
    }, {});

    filter["freeText"] = textFilter;
    filter["$or"] = [{ status_id: 3 }];

    if (!filters["opportunity_status_id"]) {
      filter["$and"] = filter["$and"] || [];
      filter["$and"].push({
        opportunity_status_id: {
          $neq: irrelevantStatusId,
        },
      });
    }

    const opportunitiesPage = {
      ...page,
      current: pageNumber,
      pageSize,
      filter,
      order: {
        field,
        order,
      },
    };

    setPage(opportunitiesPage);
  };

  return {
    createOpportunityVisible,
    setCreateOpportunityVisible,
    selectionActionModalVisible,
    setSelectionActionModalVisible,
    wizardType,
    setWizardType,
    selectionActionLoading,
    setSelectionActionLoading,
    selectionAction,
    setSelectionAction,
    textFilter,
    setTextFilter,
    irrelevantStatusId,
    setIrrelevantStatusId,
    transferPatientVisible,
    setTransferPatientVisible,
    page,
    setPage,
    selectedRowKeys,
    setSelectedRowKeys,
    onSelectChange,
    onLaunchCreateOpportunityModal,
    hideOpportunityModal,
    onLaunchSelectionActionModal,
    hideSelectionActionModal,
    getPatient,
    onLaunchChangeBranch,
    onHideTransferPatient,
    onTextChange,
    onChange,
    onStaffInchargeChange,
  };
};
